module.exports = "/_next/static/images/ai-expreg-demo2-e10704d7b35ccb0707c7e7340bc0b9ae.jpg";